import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CodeAssignmentSegmentInput  {
    _originalTypeClassName = "zERP.BO.CodeAssignmentSegmentInput";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CodeAssignmentSegmentInput.translate = translateService;
}
this.CodeAssignmentSegmentInputKey = null;
this._key = this.CodeAssignmentSegmentInputKey = 0; 
}

static translate: TranslateService;
_key: any;
private _CodeAssignmentSegmentInputKey:any;
get CodeAssignmentSegmentInputKey(): any {
    return this._CodeAssignmentSegmentInputKey;
  }
set CodeAssignmentSegmentInputKey(value: any) {
    this._CodeAssignmentSegmentInputKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CodeAssignmentSegmentInputKey == null || $this.CodeAssignmentSegmentInputKey == 0;
            }


}